export default "__VITE_ASSET__g9nJfkpC__"